module.exports = __webpack_public_path__ + "img/paymentasia.0ea89759.svg";